<template>
  <section id="tac-admin-credit-memo" class="tac-admin-credit-memo tac-admin-credit-memo__list">
    <div class="page-header">
      <h1 class="page-header-title">
        <router-link :to="{name: 'admin/credit-memo/list'}" class="page-header__title-link--no-highlight">
          <span class="fa fa-fw fa-th"></span> Credit Memo
        </router-link>
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner">
          <div class="form-group form-group-sm">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData || isFormClear()" @click="BFM_search()">Search</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData || (isFormClear() && isFilterClear() && isSorterClear())" @click="BFM_clearAll()">Clear</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group form-group-sm">
            <div class="btn-toolbar">
              <div class="btn-group btn-group-sm">
                <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" :disabled="fetchingData">New <span class="caret"></span></button>
                <ul class="dropdown-menu">
                  <li><router-link :to="linkToNewRecord('overpayment')"><i class="fa fa-fw fa-plus"></i> Over Payment</router-link></li>
                  <li><router-link :to="linkToNewRecord('freemoney')"><i class="fa fa-fw fa-money"></i> Free Money</router-link></li>
                  <li><router-link :to="linkToNewRecord('return')"><i class="fa fa-fw fa-mail-reply"></i> Return</router-link></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" @click="reload" title="Refresh Page" :disabled="fetchingData"><i class="fa fa-fw fa-refresh"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="record-browser">
        <form class="form record-browser__main-form browser-main-form browser-main-form--dark" @submit.prevent="BFM_search()">
          <div class="browser-main-form__group form-group form-group-sm main-filter__number">
            <label>Number</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.number" />
          </div>
          <div class="browser-main-form__group form-group form-group-sm main-filter__company">
            <label>Company</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.company" />
          </div>
          <div class="browser-main-form__group form-group form-group-sm main-filter__telephone">
            <label>Telephone</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.telephone" />
          </div>
          <div class="browser-main-form__group form-group form-group-sm main-filter__email">
            <label>Email</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.email" />
          </div>
          <div class="browser-main-form__group form-group form-group-sm main-filter__email">
            <label>Serial #</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.serial" placeholder="Serial #" />
          </div>
          <div class="browser-main-form__group form-group form-group-sm main-filter__amount">
            <label>Amount</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.amount" />
          </div>
          <div class="browser-main-form__group form-group form-group-sm main-filter__last-name">
            <label>Last Name</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.lastName" />
          </div>
          <div class="browser-main-form__group form-group form-group-sm main-filter__last-name">
            <label>First Name</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.firstName" />
          </div>
          <div class="browser-main-form__group form-group form-group-sm main-filter__email">
            <label>ZIP</label>
            <input :disabled="fetchingData" type="text" class="form-control" v-model="form.zip" />
          </div>
          <button type="submit" class="sr-only">Submit</button>
        </form>
        <div class="row">
          <div class="col-lg-9">
            <div class="panel panel-default record-browser__items">
              <table class="table table-bordered table-striped table-hover table-condensed">
                <thead>
                  <tr>
                    <th class="col-lg-1 text-center" @click="LSOM_toggleSort('sortNumber')">
                      <sorter-icon :order="LSOM_getSortingMethod('sortNumber')"></sorter-icon>
                      CM#
                    </th>
                    <th class="col-lg-4" @click="LSOM_toggleSort('sortCustomerName')">
                      <sorter-icon :order="LSOM_getSortingMethod('sortCustomerName')"></sorter-icon>
                      Customer
                    </th>
                    <th class="col-lg-1 text-right" @click="LSOM_toggleSort('sortAmount')">
                      <sorter-icon :order="LSOM_getSortingMethod('sortAmount')"></sorter-icon>
                      Amount
                    </th>
                    <th class="col-lg-1 text-right" @click="LSOM_toggleSort('sortAvailable')">
                      <sorter-icon :order="LSOM_getSortingMethod('sortAvailable')"></sorter-icon>
                      Available
                    </th>
                    <th class="col-lg-1 text-center" @click="LSOM_toggleSort('sortDate')">
                      <sorter-icon :order="LSOM_getSortingMethod('sortDate')"></sorter-icon>
                      Date
                    </th>
                    <th class="col-lg-1 text-center" @click="LSOM_toggleSort('sortStatus')">
                      <sorter-icon :order="LSOM_getSortingMethod('sortStatus')"></sorter-icon>
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!creditMemos.length">
                    <td class="text-center text-warning" colspan="8">
                      No credit memo found.  Try a different search parameter.
                    </td>
                  </tr>
                  <tr
                    v-for="(creditMemo, key) in creditMemos"
                    :key="key"
                    :class="{warning: LSLM_isItemSelected(creditMemo)}"
                    @click="LSLM_handleItemClick($event, creditMemo)"
                  >
                    <td class="text-center">
                      <router-link :to="linkToRecord(creditMemo)">{{ creditMemo.creditMemoNumber }}</router-link>
                    </td>
                    <td>{{ creditMemo.customer.name }}</td>
                    <td class="text-right"><money :value="creditMemo.amount"></money></td>
                    <td class="text-right"><money :value="creditMemo.available"></money></td>
                    <td class="text-center">{{ creditMemo.transactionDate | format('MM/DD/YYYY') }}</td>
                    <td class="text-center">{{ statusCodeToLabel(creditMemo.status) }}</td>
                  </tr>
                </tbody>
                <tfoot v-if="!!creditMemos.length">
                  <tr>
                    <td colspan="8">
                      <pagination
                        class="text-center pagination-compact"
                        p-show-total
                        p-show-per-page
                        p-edit-per-page
                        p-size="pagination-sm"
                        :p-total="pagination.total"
                        :p-per-page="pagination.perPage"
                        :p-page="pagination.page"
                        @open-page="openPage"
                        @per-page-change="updatePerPage($event)"
                        >
                      </pagination>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="panel panel-default record-browser__filters">
              <div class="panel-heading">
                <template v-if="LSLC_isOneItemSelected">
                <strong>[{{ LSLC_lastSelectedItemNumber }}]&nbsp;&nbsp;{{ LSLC_lastSelectedItemDate }}</strong>
                </template>
                <template v-else>
                Filter
                </template>
              </div>
              <div class="panel-body">
                <div class="form">
                  <div class="form-horizontal">
                    <div class="form-group form-group-sm">
                      <label class="control-label col-lg-4">Status</label>
                      <div class="col-lg-8">
                        <select :disabled="fetchingData" class="form-control" v-model="filter.status" @change="BFM_search()">
                          <option :value="null">All</option>
                          <option value="pending">Pending</option>
                          <option value="open">Open</option>
                          <option value="closed">Closed</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <label class="control-label col-lg-4">Type</label>
                      <div class="col-lg-8">
                        <select :disabled="fetchingData" class="form-control" v-model="filter.type" @change="BFM_search()">
                          <option :value="null">All</option>
                          <option value="return">Return</option>
                          <option value="freemoney">Free Money</option>
                          <option value="credit">Overpayment</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <label class="control-label col-lg-4">Deleted</label>
                      <div class="col-lg-8">
                        <select :disabled="fetchingData" class="form-control" v-model="filter.discarded" @change="BFM_search()">
                          <option :value="null">No</option>
                          <option value="true">Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div><!-- .panel -->
            <div class="panel panel-default">
              <div class="panel-heading">Stat</div>
              <table class="table">
                <tbody>
                  <tr>
                    <td>Open CM Return</td>
                    <td class="text-right"><money :value="statOpenReturns.value" :show-currency="true" :currency-sign="currencySign(statOpenFreeMoney.currency)" :legacy-type="false"></money></td>
                  </tr>
                  <tr>
                    <td>Open CM Free Money</td>
                    <td class="text-right"><money :value="statOpenFreeMoney.value" :show-currency="true" :currency-sign="currencySign(statOpenFreeMoney.currency)" :legacy-type="false"></money></td>
                  </tr>
                  <tr>
                    <td>Open CM Overpayment</td>
                    <td class="text-right"><money :value="statOpenOverpayment.value" :show-currency="true" :currency-sign="currencySign(statOpenOverpayment.currency)" :legacy-type="false"></money></td>
                  </tr>
                </tbody>
              </table>
            </div><!-- .panel -->
          </div><!-- .col-* -->
        </div><!-- .row -->
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import uuid from 'uuid/v4'
import { mapState, mapGetters } from 'vuex'
import { format } from '@/plugin/filter/date'
import MixinApiResponse from '@/plugin/mixin/api-response'
import MixinBrowsingForm from '@/plugin/mixin/browsing-form'
import MixinListSelection from '@/plugin/mixin/list-selection';
import MixinListSorting from '@/plugin/mixin/list-sorting';
import MixinMoney from '@/plugin/mixin/money'
import MixinPagination from '@/plugin/mixin/pagination';
import Money from '@/plugin/element/money'
import Pagination from '@/plugin/bootstrap/pagination';
import SorterIcon from '@/plugin/element/sorter-icon'

const FORM_MODEL = {
  number      : null,
  amount      : null,
  batchNumber : null,
  company     : null,
  firstName   : null,
  lastName    : null,
  telephone   : null,
  email       : null,
  zip         : null,
  date        : null,
  serial      : null,
}

const FILTER_MODEL = {
  status        : null,
  type          : null,
  method        : null,
  deposited     : null,
  noBatchNumber : null,
  discarded     : null
}

const SORTER_MODEL = {
  sortNumber       : null,
  sortCustomerName : null,
  sortAmount       : null,
  sortAvailable    : null,
  sortDate         : null,
  sortStatus       : null,
}

const PAGINATION_PER_PAGE = 'vue.admin.credit-memo.record.pagination.per-page'

export default {
  name: 'list',
  data() {
    return {
      form     : _.cloneDeep(FORM_MODEL),
      filter   : _.cloneDeep(FILTER_MODEL),
      sorter   : _.cloneDeep(SORTER_MODEL),
      selected : {items: []},
    }
  },
  created() {
    this.BFM_setDefaultIsBusyGetter('data', 'fetchingData')
    this.BFM_setDefaultFormModelGetter('callback', () => {return FORM_MODEL})
    this.BFM_setDefaultFilterModelGetter('callback', () => {return FILTER_MODEL})
    this.BFM_setDefaultSorterModelGetter('callback', () => {return SORTER_MODEL})

    this.LSLM_setDefaultSelectedItemsPath('selected.items')
    this.LSLM_setDefaultItemIdentifierName('uuid')
    this.LSLM_setDefaultOpenRecordCallback('openRecord')

    this.$alertify.dismissAll()

    this.BFM_loadAllFromRoute()
    this.fetchData()
  },
  watch: {
    $route() {
      this.BFM_loadAllFromRoute()
      this.fetchData()
    },
    sorter() {
      this.BFM_search()
    },
    creditMemos: {
      deep: true,
      handler() {
        if (1 !== this.totalItems || 1 != this.pagination.total || !this.BFC_autoOpen) {
          return
        }
        this.$router.push(this.linkToRecord(_.first(this.creditMemos)))
      }
    }
  },
  computed: {
    ...mapState('creditMemo/records', {
      creditMemos: 'items',
      pagination: 'pagination',
      fetchingData: 'requested',
    }),
    ...mapGetters('creditMemo/records', {
      currencySign: 'currencySign',
      statOpenReturns: 'statOpenReturns',
      statOpenFreeMoney: 'statOpenFreeMoney',
      statOpenOverpayment: 'statOpenOverpayment',
    }),
    totalItems() {
      return (this.creditMemos || []).length
    },
    isAnyItemSelected() {
      return this.selected.items.length > 0
    },
    isOneItemSelected() {
      return this.selected.items.length === 1
    },
    isMultipleItemsSelected() {
      return this.selected.items.length > 1
    },
    lastSelectedItemNumber() {
      return this.lastSelectedItem.creditMemoNumber
    },
    lastSelectedItemDate() {
      return moment(this.lastSelectedItem.transactionDate, 'YYYY-MM-DD').format('MM/DD/YYYY hh:mm:ssa')
    },
    lastSelectedItem() {
      return _.last(this.selected.items)
    }
  },
  methods: {
    reload() {
      this.fetchData()
    },
    updatePerPage(val) {
      if (val) {
        window.localStorage.setItem(PAGINATION_PER_PAGE, val)
      } else {
        window.localStorage.removeItem(PAGINATION_PER_PAGE)
      }

      this.$store.dispatch('creditMemo/records/changePerPage', val)
      this.PGM_changeRoutePerPage(val)
      this.fetchData()
    },
    openPage(page) {
      this.$store.dispatch('creditMemo/records/changePage', page)
      this.PGM_changeRoutePage(page)
      this.fetchData()
    },
    fetchData() {
      this.$store.dispatch('creditMemo/records/updateFilter', this.BFM_compileFilters())
      this.$store.dispatch('creditMemo/records/updateSorter', this.BFM_compileSorters())

      if (this.$route.query.page) {
        this.$store.dispatch('creditMemo/records/changePage', this.$route.query.page * 1)
      } else {
        this.$store.dispatch('creditMemo/records/changePage', 1)
      }

      if (this.$route.query.perPage) {
        this.$store.dispatch('creditMemo/records/changePerPage', this.$route.query.perPage * 1)
      } else {
        this.$store.dispatch('creditMemo/records/changePerPage', 10)
      }

      this.$store.dispatch('creditMemo/records/fetch')
    },
    openRecord(creditMemo) {
      this.$router.push(this.linkToRecord(creditMemo))
    },
    linkToRecord(creditMemo) {
      const params = Object.assign({}, _.cloneDeep(this.$route.params), {
        action         : 'view',
        creditMemoUuid : creditMemo.uuid,
      })
      let query = _.cloneDeep(this.$route.query)
      if (_.has(query, 'autoOpen')) {
        delete query.autoOpen
      }

      return {
        name   : 'admin/credit-memo/record',
        params : params,
        query  : query,
      }
    },
    linkToNewRecord(type) {
      return {
        name  : 'admin/credit-memo/new',
        params: {type},
        query : Object.assign(_.cloneDeep(this.$route.query), {_t: uuid().substr(-12)}),
      }
    },
    isFormClear() {
      return !_.get(this.form, 'number')
        && !_.get(this.form, 'amount')
        && !_.get(this.form, 'batchNumber')
        && !_.get(this.form, 'company')
        && !_.get(this.form, 'firstName')
        && !_.get(this.form, 'lastName')
        && !_.get(this.form, 'telephone')
        && !_.get(this.form, 'email')
        && !_.get(this.form, 'zip')
        && !_.get(this.form, 'date')
        && !_.get(this.form, 'serial')
    },
    isFilterClear() {
      return _.isEqual(this.filter, FILTER_MODEL)
        || (
          !_.get(this.filter, 'method')
          && !_.get(this.filter, 'status')
          && !_.get(this.filter, 'type')
          && !_.get(this.filter, 'deposited')
          && !_.get(this.filter, 'noBatchNumber')
          && !_.get(this.filter, 'discarded')
          && !_.isEqual(this.filter, FILTER_MODEL)
        )
    },
    isSorterClear() {
      return _.isEqual(this.sorter, SORTER_MODEL)
        || (
          !_.get(this.sorter, 'sortNumber')
          && !_.get(this.sorter, 'sortCustomerName')
          && !_.get(this.sorter, 'sortAmount')
          && !_.get(this.sorter, 'sortAvailable')
          && !_.get(this.sorter, 'sortDate')
          && !_.get(this.sorter, 'sortStatus')
          && !_.isEqual(this.sorter, SORTER_MODEL)
        )
    },
    statusCodeToLabel(code) {
      if ('pending' === code) {
        return 'Pending'
      }
      if ('open' === code) {
        return 'Open'
      }
      if ('closed' === code) {
        return 'Closed'
      }
      return code
    },
  },
  components: {
    Money,
    Pagination,
    SorterIcon
  },
  filters: {
    format
  },
  mixins: [
    MixinApiResponse,
    MixinBrowsingForm,
    MixinListSelection,
    MixinListSorting,
    MixinMoney,
    MixinPagination
  ]
}
</script>
